import getStore from 'services/getStore';
import {
  getScore,
  setScore,
  rehydrateScore,
  getScoreRaw,
  getScorePercent,
  getAllScoringInteractions,
} from 'services/scoring';
import getAllInteractions from 'services/apiHelpers/getAllInteractions';
import getBlockById from 'services/apiHelpers/getBlockById';
import { SCORM } from 'pipwerks-scorm-api-wrapper';
import API from 'services/scorm/API';
import { getLastInteractionSeen } from 'services/apiHelpers/isLastInteraction';
import isLastInteraction from 'services/apiHelpers/isLastInteraction';

const store = getStore();

let scorm;
let completionStatus;
let allPagesViewed;
let savedInteractionsSeen = [];
let interactionsLockedData = {};
let multichoiceData = {};

let CMIInteractionsIds = [];
// this broke the thing. sorry sam
// let CMIInteractionsIds = getAllInteractions().filter((i: any) =>
//   ['Multichoice', 'Sortation'].includes(getBlockById(i).meta.subType)
// );

let delaySetSCORM;

try {
  scorm = SCORM.init();
} catch (err) {
  console.log('scorm aint happy outside of LMS');
}

let scormInit;
let version = SCORM.version || '1.2';
let location;

let unloaded;
['beforeunload', 'unload'].forEach(e =>
  window.addEventListener(e, () => {
    if (unloaded) return;

    saveAndQuit();
    unloaded = true;
  })
);

const getLocation = (local = false) => {
  if (local) {
    // testing
    return sessionStorage.getItem('TESTING_LIZARD_BOOKMARKING');
  }

  if (!scorm) {
    return;
  }

  const entry = SCORM.get(API[version].entry);

  return entry === 'ab-initio'
    ? null
    : version
    ? SCORM.get(API[version].location)
    : null;
};

const getSuspendData = () =>
  version && scormInit ? SCORM.get(API[version].suspend_data) : null;

const onExit = () => {
  // console.log('bye !!!');
  if (scorm) {
    saveAndQuit();
  }

  setTimeout(() => {
    if (window.self === window.top) {
      window.close();
    } else {
      window.top.close();
    }
  }, 100);
};

const getScoreData = () => {
  const allScoringInteractions = getAllScoringInteractions();
  const hasScoring = !!allScoringInteractions.length;
  const scoreRaw = getScoreRaw();
  const scorePercent = getScorePercent();

  return {
    allScoringInteractions,
    hasScoring,
    scoreRaw,
    scorePercent,
  };
};

const setScoreData = () => {
  const {
    allScoringInteractions,
    hasScoring,
    scoreRaw,
    scorePercent,
  } = getScoreData();

  if (hasScoring) {
    SCORM.set(API[version].scoreMin, 0);
    SCORM.set(API[version].scoreMax, allScoringInteractions.length);
    SCORM.set(API[version].scoreRaw, scoreRaw);

    if (version === '2004') {
      SCORM.set(
        API[version].scoreScaled,
        scoreRaw / allScoringInteractions.length
      );
      SCORM.set(API[version].success, scorePercent >= 80 ? 'passed' : 'failed');
    }
  }
};

const setComplete = (completed: boolean) => {
  SCORM.set(API[version].completion, completed ? 'completed' : 'incomplete');
};

const saveAndQuit = () => {
  SCORM.save();
  SCORM.quit();
};

const exit = () => {
  if (!scorm) return;

  const { scormSettings } = store.getState();
  const {
    setCompleteWhenAllPagesViewed,
    setCompleteFromScore,
    setCompleteOnExit,
    passMark,
  } = scormSettings;

  const { scorePercent } = getScoreData();

  // inlining this first up
  // refactor later. . .

  if (setCompleteOnExit) {
    // we won't send any scoring from here
    // if scoring was a requirement author ' should ' be using setCompleteFromScore
    // setScoreData();

    // isLastInteraction : enforce exit from last page ?
    // getLastInteractionSeen() : we've navigated to the last page. completion is assumed
    // we can go back to anywhere else and close. still sets complete
    // this would be the ' safest ' way i reckon

    if (getLastInteractionSeen()) {
      setComplete(true);
      saveAndQuit();
    }
    return;
  }

  //
  if (setCompleteWhenAllPagesViewed && !setCompleteFromScore) {
    if (allPagesViewed) {
      // only send score when. . .
      setScoreData();

      setComplete(true);
    } else {
      setComplete(false);
    }

    saveAndQuit();
    return;
  }

  if (!setCompleteWhenAllPagesViewed && setCompleteFromScore) {
    if (getLastInteractionSeen()) {
      setScoreData();

      if (scorePercent >= Number(passMark)) {
        setComplete(true);
      } else {
        setComplete(false);
      }
    } else {
      // will ( should ) already be incomplete
      setComplete(false);
    }

    saveAndQuit();
    return;
  }

  if (setCompleteWhenAllPagesViewed && setCompleteFromScore) {
    if (allPagesViewed) {
      setScoreData();
      if (scorePercent >= passMark) {
        setComplete(true);
      } else {
        setComplete(false);
      }
    } else {
      setComplete(false);
    }

    saveAndQuit();
    return;
  }
};

const getInteractionsLockedData = (id = null) => {
  return id ? interactionsLockedData[id] : interactionsLockedData;
};

const setInteractionsLockedData = id => {
  interactionsLockedData[id] = 0;
};

const getMultichoiceData = () => {
  let savedMultichoiceData = getSuspendData();
  savedMultichoiceData = savedMultichoiceData
    ? JSON.parse(savedMultichoiceData)
    : {};

  return savedMultichoiceData.multichoiceData
    ? savedMultichoiceData.multichoiceData
    : multichoiceData;
};

const setMultichoiceData = data => {
  multichoiceData[data.id] = data;
};

const getCMIInteractionsId = id => {
  // moved up into ' init '
  // if (!CMIInteractionsIds) {
  //   CMIInteractionsIds = getAllInteractions().filter((i: any) =>
  //     ['Multichoice', 'Sortation'].includes(getBlockById(i).meta.subType)
  //   );
  // }

  return CMIInteractionsIds.indexOf(id);

  // if (!CMIInteractionsIds.includes(id)) {
  //   CMIInteractionsIds.push(id);
  // }
  // return CMIInteractionsIds.length - 1;
};

const getQuestion = (question, compress = false) =>
  compress
    ? question.replace(/ |\r|\n/g, '_').replace(/[^a-zA-Z0-9 -]/g, '')
    : question;

const getResult = result => {
  if (version === '1.2') {
    return result ? 'correct' : 'wrong';
  }

  return result ? 'correct' : 'incorrect';
};

const setCMIInteractionsMultichoice = data => {
  const { id, question, type, response = 'pending', result } = data;

  // console.log('setCMIInteractionsMultichoice:', { id, type, response, result });

  if (!scorm) return;

  // SCORM.set(
  //   `cmi.interactions.${id}.id`,
  //   version === '1.2' ? getQuestion(question, true) : `Question${id}`
  // );
  SCORM.set(`cmi.interactions.${id}.id`, `Question${id}`);

  if (version !== '1.2') {
    SCORM.set(`cmi.interactions.${id}.description`, getQuestion(question));
  }
  SCORM.set(`cmi.interactions.${id}.type`, type);
  SCORM.set(
    `cmi.interactions.${id}.${
      version === '1.2' ? 'student_response' : 'learner_response'
    }`,
    response
  );
  SCORM.set(`cmi.interactions.${id}.result`, getResult(result));
};

const setCMIInteractionsSortation = data => {
  let { id, type, response = 'pending', result } = data;

  // console.log('setCMIInteractionsSortation:', { id, type, response, result });

  if (!scorm) return;

  SCORM.set(`cmi.interactions.${id}.id`, `Question${id}`);
  SCORM.set(`cmi.interactions.${id}.type`, type);
  SCORM.set(
    `cmi.interactions.${id}.${
      version === '1.2' ? 'student_response' : 'learner_response'
    }`,
    response
  );
  SCORM.set(`cmi.interactions.${id}.result`, getResult(result));
};

const getSavedInteractionsSeen = () => {
  return savedInteractionsSeen;
};

export {
  getLocation,
  getSavedInteractionsSeen,
  getSuspendData,
  getInteractionsLockedData,
  setInteractionsLockedData,
  setMultichoiceData,
  getMultichoiceData,
  getCMIInteractionsId,
  setCMIInteractionsMultichoice,
  setCMIInteractionsSortation,
  onExit,
};
